//React Imports
import React, { useState, Fragment } from "react";
import "./styles.css";
import { Category } from "common/utils/menu-helper-utils";
import { useSelector } from "react-redux";
import { RootState } from "common/rootReducer";

interface DesktopCategoryFilterProps {
  categories: Category;
  setCurrentCategory: any;
  currentCategory: string;
  showCategory: any;
  specialMenuCategory?: any;
  getPreviouslyOrderedMenuText?: any;
  setCurrentRestaurantDishViewType?: any;
  currentRestaurantDishViewType?: string;
}

function DesktopCategoryFilter(props: DesktopCategoryFilterProps) {
  const [showCategories, setShowCategories] = useState(true);
  const menuCategories: Array<string> = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuCategories
  );
  const menuDetails = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetails
  );

  const allItemsQty = Object.values(props.categories)
    .map((item) => item.quantity)
    .reduce((acc, cur) => acc + cur, 0);

  const isPreviouslyOrdered = menuDetails?.filter(
    (item) => item?.isPreviouslyOrdered
  );

  return (
    <Fragment>
      <div className="desktop-category-filter-container">
        <div className="desktop-category-filter-innercontainer">
          <span className="category-field">
            <div
              className={
                props.currentCategory == "" &&
                props.currentRestaurantDishViewType === "All Items"
                  ? "merchant-category-value category-value-selected "
                  : "merchant-category-value"
              }
              onClick={() => {
                props.setCurrentRestaurantDishViewType("All Items");
                if (props.currentCategory == "") {
                  props.setCurrentCategory("");
                } else {
                  props.showCategory("");
                  props.setCurrentCategory("");
                }
                setShowCategories(false);
              }}
            >
              <span>All Items ({allItemsQty})</span>
              {/* <span>{props.categories.quantity}</span> */}
            </div>
          </span>

          <span className="category-field">
            <div
              className={
                props.currentCategory == "" &&
                (props.currentRestaurantDishViewType === "Recommendation" ||
                  props.currentRestaurantDishViewType ===
                    "Previously Ordered" ||
                  props.currentRestaurantDishViewType === "Special Menu")
                  ? "merchant-category-value category-value-selected "
                  : "merchant-category-value"
              }
              onClick={() => {
                isPreviouslyOrdered?.length > 0
                  ? props.setCurrentRestaurantDishViewType("Previously Ordered")
                  : props.setCurrentRestaurantDishViewType("Special Menu");
                if (props.currentCategory == "") {
                  props.setCurrentCategory("");
                } else {
                  props.showCategory("");
                  props.setCurrentCategory("");
                }
                setShowCategories(false);
              }}
            >
              <span>Recommendation</span>
            </div>
          </span>

          {/* {props.specialMenuCategory &&
            props.specialMenuCategory().length > 0 && (
              <span>
                <div
                  className={
                    props.currentCategory == ""
                      ? "category-field"
                      : "category-field"
                  }
                >
                  {props.specialMenuCategory &&
                    props.specialMenuCategory().map((name: string, i: any) => {
                      return (
                        <div
                          className={
                            (props.currentRestaurantDishViewType !== "All Items" && props.currentRestaurantDishViewType !== "Recommendation")
                              ? "merchant-category-value category-value-selected "
                              : "merchant-category-value"
                          }
                          key={i}
                          onClick={() => {
                            props.setCurrentRestaurantDishViewType(name);
                            props.showCategory("");
                            props.setCurrentCategory("");
                          }}
                        >
                          <span>{name}</span>
                        </div>
                      );
                    })}
                </div>
              </span>
            )} */}
          {menuCategories &&
            menuCategories
              .filter((category) =>
                Object.keys(props.categories).includes(category)
              )
              .map((category: string, index: number) => (
                <span className="category-field">
                  <div
                    className={
                      props.currentCategory == category
                        ? "merchant-category-value category-value-selected "
                        : "merchant-category-value"
                    }
                    key={index}
                    onClick={() => {
                      props.setCurrentRestaurantDishViewType("All Items");
                      if (props.currentCategory == category) {
                        props.setCurrentCategory("");
                      } else {
                        props.showCategory(category);
                        props.setCurrentCategory(category);
                      }
                      setShowCategories(false);
                    }}
                  >
                    <span>
                      {category} ({props.categories[category].quantity})
                    </span>
                  </div>
                </span>
              ))}
        </div>
      </div>
    </Fragment>
  );
}

export default DesktopCategoryFilter;
